// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import i18n from './i18n'
Vue.config.productionTip = false
import headers from "./components/headers";
import footers from "./components/footers";
import toTop from "./components/toTop";

Vue.component('headers', headers)
Vue.component('footers', footers)
Vue.component('toTop', toTop)
router.beforeEach((to, from, next) => {
  document.body.style.overflow = "scroll",
  next()
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/client/index.js